import React from 'react';
import { Box, Container, Typography, Link, Stack, IconButton } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { brand, COMPANY_PHONE, COMPANY_PHONE_TEL, COMPANY_ADDRESS_INLINE, COMPANY_EMAIL_DOCUMENT } from '../brandTheme';

const Footer = () => {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const nav = [
    { label: 'Home', href: '#/home' },
    { label: 'About', href: '#/about' },
    { label: 'Services', href: '#/services' },
    { label: 'Insurance', href: '#/insurance' },
    { label: 'Contact', href: '#/contact' },
  ];

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: brand.surfaceWarm,
        color: brand.slate,
        borderTop: `1px solid ${brand.border}`,
        py: { xs: 3, md: 3.5 },
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2.5, md: 3 }}
          alignItems={{ xs: 'flex-start', md: 'center' }}
          justifyContent="space-between"
          flexWrap="wrap"
          useFlexGap
        >
          <Box sx={{ minWidth: { md: 200 } }}>
            <Typography sx={{ fontWeight: 800, fontSize: '1.05rem', color: brand.primary, letterSpacing: '-0.02em' }}>
              Om Sai <Box component="span" sx={{ color: brand.accent }}>Enterprises</Box>
            </Typography>
            <Typography variant="caption" sx={{ color: brand.muted, display: 'block', mt: 0.5, maxWidth: 280, lineHeight: 1.5 }}>
              Loans & insurance advisory · Thane West
            </Typography>
          </Box>

          <Stack
            direction="row"
            component="nav"
            flexWrap="wrap"
            useFlexGap
            spacing={1}
            columnGap={2}
            rowGap={0.5}
            sx={{ alignItems: 'center' }}
          >
            {nav.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                onClick={scrollTop}
                underline="none"
                sx={{
                  color: brand.muted,
                  fontWeight: 600,
                  fontSize: '0.8125rem',
                  '&:hover': { color: brand.primary },
                }}
              >
                {item.label}
              </Link>
            ))}
          </Stack>

          <Stack direction="row" spacing={0.75} alignItems="center">
            <IconButton
              size="small"
              aria-label="Facebook"
              sx={{ color: brand.muted, border: `1px solid ${brand.border}`, bgcolor: '#fff' }}
            >
              <FacebookIcon fontSize="small" />
            </IconButton>
            <IconButton
              size="small"
              aria-label="LinkedIn"
              sx={{ color: brand.muted, border: `1px solid ${brand.border}`, bgcolor: '#fff' }}
            >
              <LinkedInIcon fontSize="small" />
            </IconButton>
          </Stack>
        </Stack>

        <Typography
          variant="caption"
          sx={{
            display: 'block',
            mt: 2,
            pt: 2,
            borderTop: `1px solid ${brand.border}`,
            color: brand.muted,
            fontSize: '0.75rem',
            lineHeight: 1.6,
          }}
        >
          <Box component="span" sx={{ color: brand.slate, fontWeight: 600 }}>
            {COMPANY_PHONE}
          </Box>
          {' · '}
          <Link href={COMPANY_PHONE_TEL} underline="hover" sx={{ color: brand.primary, fontWeight: 600 }}>
            Call
          </Link>
          {' · '}
          <Link href={`mailto:${COMPANY_EMAIL_DOCUMENT}`} underline="hover" sx={{ color: brand.primary, fontWeight: 600 }}>
            {COMPANY_EMAIL_DOCUMENT}
          </Link>
          <br />
          {COMPANY_ADDRESS_INLINE}
        </Typography>

        <Typography variant="caption" sx={{ display: 'block', mt: 1.5, color: brand.muted, textAlign: 'center', fontSize: '0.7rem' }}>
          © {new Date().getFullYear()} omsaifin.com · Om Sai Enterprises
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
